import React from "react";
import styled from "styled-components";
import CaretIcon from "sweet-web/components/icons/CaretIcon";
import Loading from "sweet-web/components/universal/Loading";
import { colors } from "sweet-web/lib/styles";

const StyledButton = styled.button<{ primary: boolean }>`
  padding: 2px 10px;
  background-color: ${colors.white};
  color: ${props => (props.primary ? colors.primary : colors.gray)};
  border: 1px solid
    ${props => (props.primary ? colors.primary : colors.lightGray)};
  font-size: 14px;
  font-weight: 600;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  border-radius: 5px;
  outline: none;
  &:hover {
    transform: scale(1.03);
    border-color: ${props => (props.primary ? colors.primary : colors.gray)};
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
  }
  position: fixed;
  right: 45px;
  bottom: 45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

type Props = {
  onClick?: () => void;
  style?: object;
  primary?: boolean;
  loading?: boolean;
};
const NextButton: React.FC<Props> = props => {
  return (
    <StyledButton
      style={props.style}
      primary={props.primary}
      onClick={props.onClick}
    >
      Next
      {props.loading ? (
        <Loading
          size={18}
          color="primary"
          style={{ marginLeft: 5, marginTop: 6, marginBottom: 6 }}
        />
      ) : (
        <CaretIcon
          size={17}
          color={props.primary ? colors.primary : colors.gray}
          style={{
            marginLeft: 10,
            marginTop: 6
          }}
        />
      )}
    </StyledButton>
  );
};
NextButton.defaultProps = {
  style: {},
  primary: false,
  loading: false
};

export default NextButton;
